import Button from "@/components/button/Button.tsx";
import classNames from "classnames";
import type {ButtonHTMLAttributes} from "react";
import {CalendarDay, Modifiers} from "react-day-picker";

// This type comes from react-day-picker, neither the unnamed part of the type nor the full type is exported from the library.
export type DayPickerButtonProps = {
  /** The day to render. */
  day: CalendarDay;
  /** The modifiers to apply to the day. */
  modifiers: Modifiers;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const DayPickerButton = ({modifiers, className, ...rest}: DayPickerButtonProps) => {
  const isActive = modifiers.selected || modifiers.range_middle || modifiers.range_end;
  const isToday = modifiers.today;
  const isRangeStart = modifiers.range_start;
  return (
    <Button
      className={classNames(className, {
        today: isToday && !isActive,
        start: isRangeStart,
        active: isActive,
      })}
      {...rest}
      variant={"datePicker"}
    />
  );
};
